export const SELECTED_PACKS = '__selectedBulkAdPacks';
export const DEFAULT_SELECTED_PACKID = 1;
